export const getExportTriggered = (state) => state.courseExport.exportTriggered;
export const getCurrentStage = (state) => state.courseExport.currentStage;
export const getDownloadPath = (state) => state.courseExport.downloadPath;
export const getSuccessDate = (state) => state.courseExport.successDate;
export const getError = (state) => state.courseExport.error;
export const getIsErrorModalOpen = (state) => state.courseExport.isErrorModalOpen;
export const getLoadingStatus = (state) => state.courseExport.loadingStatus;
export const getSavingStatus = (state) => state.courseExport.savingStatus;
